import client from 'shared/ApiClient';
import { recruitClient } from 'recruit/api/api_client';

interface SignUpPayload {
    first_name: string;
    last_name: string;
    email: string;
    phone_number: string;
}

interface CompletePayload extends SignUpPayload {
    password: string;
    verified_via: 'sms' | 'email';
}

export function recruitLogin(email: string, password: string) {
    return client('api/rest-auth/login/', {
        body: {
            username: email.toLowerCase(),
            password,
        },
    });
}

export function recruitSignUp(data: SignUpPayload) {
    return client('recruit/candidate-auth/signup/', {
        body: data,
    });
}

export function recruitVerify(phoneNumber: string, code: string) {
    return recruitClient('recruit/candidate-auth/verify/', {
        body: { phone_number: phoneNumber, code },
    });
}

export function recruitComplete(data: CompletePayload) {
    return client('recruit/candidate-auth/complete/', {
        body: data,
    });
}

export function recruitVerifyEmail(token: string) {
    return client('recruit/candidate-auth/verify-email/', {
        body: { token },
    });
}

export function sendVerification(phoneNumber: string) {
    return client('api/send-verification/', {
        body: { phone_number: phoneNumber },
    });
}

export function resendVerification(channel: 'sms' | 'email', token?: string) {
    return client('recruit/candidate-auth/resend-verification/', {
        body: { channel },
        token: token || undefined,
    });
}

export function getCandidateIdentity(token?: string) {
    return client('recruit/candidate-auth/identity/', { token: token || undefined });
}
